import About from "./pages/about/About";
import Categories from "./pages/categories/Categories";
import Contact from "./pages/contact/Contact";
import Home from "./pages/home/Home";

export const grid_data = [
    {
        brandName: "Future\nGenerali",
        title: "'Roh Kamaya Kya' Starring\nAnil Kapoor Ft. SlowCheeta.",
        image: "assets/images/home/grid/gallery_1.png",
        videoId: "8UT-sXWD2kw",
        category: "TV Ads",
        showOnHomeGrid: true
    },

    {
        brandName: "Tata\nMotors",
        title: "टाटा मोटर्स कमर्शियल व्हीकल्स |\nBS6 फेज 2 रेडी",
        image: "assets/images/home/grid/gallery_2.png",
        videoId: "GkgiiOCT-8U",
        category: "TV Ads",
        showOnHomeGrid: true
    },
    {
        brandName: "Royal Enfield x\nInterceptor",
        title: "Royal Enfield Interceptor\n650 Twin 2021 | Easy Got Back",
        image: "assets/images/home/grid/gallery_3.png",
        videoId: "rWDy8ql1K9g",
        category: "TV Ads",
        showOnHomeGrid: true
    },
    {
        brandName: "Emami Navratna\nMaxx Cool",
        title: "Varun Dhawan | Thanda\nThanda Cool Cool",
        image: "assets/images/home/grid/gallery_4.png",
        videoId: "JJNguqY9ES0",
        category: "TV Ads",
        showOnHomeGrid: true
    },
    {
        brandName: "Tata AIG x\nRanbir Kapoor",
        title: "Ft. Ranbir Kapoor, Tata AIG presents\n'Trusted Naam Fantastic Kaam'",
        image: "assets/images/home/grid/gallery_5.png",
        videoId: "8bgfj_AYC20",
        category: "TV Ads",
        showOnHomeGrid: true
    },
    {
        brandName: "Bajaj\nAllianz",
        title: "Care Heroes- ft. Ajeet Singh",
        image: "assets/images/home/grid/gallery_6.png",
        videoId: "QFzZ26il1ls",
        category: "TV Ads",
        showOnHomeGrid: true
    },
    {
        brandName: "Spotify x\nStudent Plan",
        title: "Spotify Premium Student",
        image: "assets/images/home/grid/gallery_7.png",
        videoId: "7ZSz65Abe2E",
        category: "TV Ads",
        showOnHomeGrid: true
    },
    {
        brandName: "Oven\nStory",
        title: "Oven Story Pizza |\nStandout Toppings",
        image: "assets/images/home/grid/gallery_8.png",
        videoId: "7KMrl5UtrDQ",
        category: "TV Ads",
        showOnHomeGrid: true
    },
    {
        brandName: "Nua",
        title: "Nua x Deepika Padukone |\nCramp Comfort Heat Patch",
        image: "assets/images/home/grid/gallery_9.png",
        videoId: "BIdjuaJu-Wc",
        category: "TV Ads",
        showOnHomeGrid: true
    },


    {
        brandName: "Tata AIG x\nRanbir Kapoor",
        title: "Trusted Naam Fantastic Kaam",
        image: "assets/images/home/grid/gallery_10.png",
        videoId: "2YA-GpDcsFw",
        category: "TV Ads",
        showOnHomeGrid: false
    },
    {
        brandName: "Spotify\nPremium",
        title: "Spotify Premium Mini: Sangeet",
        image: "assets/images/home/grid/gallery_11.png",
        videoId: "oB8ZlsOO1iY",
        category: "TV Ads",
        showOnHomeGrid: false
    },
    {
        brandName: "Thomas\nCook",
        title: "#CricketDateWithDad",
        image: "assets/images/home/grid/gallery_12.png",
        videoId: "N3JreMa6WWo",
        category: "TV Ads",
        showOnHomeGrid: false
    },
    {
        brandName: "Tata Motors x\nTurbotronn",
        title: "Turbotronn 2.0 | Bachat Bhi Bharosa Bh",
        image: "assets/images/home/grid/gallery_13.png",
        videoId: "mK4T76kX3K0",
        category: "TV Ads",
        showOnHomeGrid: false
    },
    {
        brandName: "Chaayos",
        title: "Chai + Snacks = Relax",
        image: "assets/images/home/grid/gallery_14.png",
        videoId: "ZUe5sznWpwk",
        category: "TV Ads",
        showOnHomeGrid: false
    },
    {
        brandName: "ITC\nMaster Chef",
        title: "Cooking is everyone's calling #AbKoiBhiChef",
        image: "assets/images/home/grid/gallery_15.png",
        videoId: "p6WOFynzPMM",
        category: "TV Ads",
        showOnHomeGrid: false
    },
    {
        brandName: "Iodex",
        title: "Sivajalapati's Thaipusam Walk #Iodex",
        image: "assets/images/home/grid/gallery_16.png",
        videoId: "p5QtyvqPtLA",
        category: "TV Ads",
        showOnHomeGrid: false
    },
    {
        brandName: "Faasos",
        title: "Boring Hata Faasos Manga | #BoreHoTohBoldo",
        image: "assets/images/home/grid/gallery_17.png",
        videoId: "v2me7iZFsP4",
        category: "TV Ads",
        showOnHomeGrid: false
    },
    {
        brandName: "USPA",
        title: "U.S. POLO ASSN. AW'22 #PlayTogether Campaign",
        image: "assets/images/home/grid/gallery_18.png",
        videoId: "VmTwe119tTY",
        category: "TV Ads",
        showOnHomeGrid: false
    },
    {
        brandName: "Bajaj Allianz x\nDiwali Unboxing",
        title: "Diwali Unboxing with Chintu | Happy Diwali 2019",
        image: "assets/images/home/grid/gallery_19.png",
        videoId: "9h05PK0tqcg",
        category: "TV Ads",
        showOnHomeGrid: false
    },
    {
        brandName: "Car\nDekho",
        title: "Insure your two-wheeler with InsuranceDekho & Save up to 70%",
        image: "assets/images/home/grid/gallery_20.png",
        videoId: "56AGEocPXII",
        category: "TV Ads",
        showOnHomeGrid: false
    },
    {
        brandName: "Faasos",
        title: "Boring Hata Faasos Manga | #BoreHoTohBoldo | Office - Hindi",
        image: "assets/images/home/grid/gallery_21.png",
        videoId: "t_lWIIcr2ZM",
        category: "TV Ads",
        showOnHomeGrid: false
    },
    {
        brandName: "Oven\nStory",
        title: "No More Crust Issues! Ovenstory Pizza - No More Crust Issues!",
        image: "assets/images/home/grid/gallery_22.png",
        videoId: "9w7hyX9dfL8",
        category: "TV Ads",
        showOnHomeGrid: false
    },
    {
        brandName: "Ajio Business:\nIndia's Largest Fashion Retail App",
        title: "Poore India ka Fashion | #AapkaApnaPartner",
        image: "assets/images/home/grid/gallery_23.png",
        videoId: "6UaYpCm6s9o",
        category: "TV Ads",
        showOnHomeGrid: false
    },
    {
        brandName: "Bajaj\nAllianz",
        title: "#PlankForIndia - Take The Plank Challenge | Bajaj Allianz Life",
        image: "assets/images/home/grid/gallery_24.png",
        videoId: "M0OtjPYGdsM",
        category: "TV Ads",
        showOnHomeGrid: false
    },
    {
        brandName: "Mcdonalds",
        title: "Mccafe Coffee | Mccafe India| McDonald's",
        image: "assets/images/home/grid/gallery_25.png",
        videoId: "1VU8VEGKQcY",
        category: "TV Ads",
        showOnHomeGrid: false
    },
    {
        brandName: "Pampers",
        title: "Pampers pants se har raat khush - Pampers jingle",
        image: "assets/images/home/grid/gallery_26.png",
        videoId: "ZFUaPjjVyIQ",
        category: "TV Ads",
        showOnHomeGrid: false
    },
    {
        brandName: "Spotify x\nNuclea",
        title: "Ad free Music | Spotify Premium | India",
        image: "assets/images/home/grid/gallery_27.png",
        videoId: "Vv1tKb4K4wg",
        category: "TV Ads",
        showOnHomeGrid: false
    },
    {
        brandName: "Tata\nSampann",
        title: "#LautAayiDiwali with Tata Sampann & Sanjeev Kapoor",
        image: "assets/images/home/grid/gallery_28.png",
        videoId: "zUIZnsxy7aw",
        category: "TV Ads",
        showOnHomeGrid: false
    },
    {
        brandName: "PubG",
        title: "",
        image: "assets/images/home/grid/gallery_29.png",
        videoId: "BI-ahXDPuP8",
        category: "TV Ads",
        showOnHomeGrid: false
    },
    {
        brandName: "Mercedes x\nF1 British GP",
        title: "-",
        image: "assets/images/home/grid/gallery_30.png",
        videoId: "q6U7JWPZpNU",
        category: "TV Ads",
        showOnHomeGrid: false
    },
    {
        brandName: "Mercedes x\nF1 Italian GP",
        title: "",
        image: "assets/images/home/grid/gallery_31.png",
        videoId: "4HVgMY9LC70",
        category: "TV Ads",
        showOnHomeGrid: false
    },
    {
        brandName: "Mercedes x\nF1 Canada GP",
        title: "",
        image: "assets/images/home/grid/gallery_32.png",
        videoId: "G69xNTOOpRc",
        category: "TV Ads",
        showOnHomeGrid: false
    },
    {
        brandName: "Dole",
        title: "Dadi Ke Mann Ki Baat | Dole Utsav Soft Dried Fruits – Too Good to Gift Away",
        image: "assets/images/home/grid/gallery_33.png",
        videoId: "TmbwtrRwaBg",
        category: "TV Ads",
        showOnHomeGrid: false
    },
    {
        brandName: "Royal Enfield x\nHimalayan",
        title: "Royal Enfield Himalayan #AllRoadsNoRoads | New Adventures Begin Today",
        image: "assets/images/home/grid/gallery_34.png",
        videoId: "1wnLbb_CAXc",
        category: "TV Ads",
        showOnHomeGrid: false
    },
    {
        brandName: "Royal Enfield x\nContinental GT",
        title: "Royal Enfield Continental GT 650 Twin 2021 | A Ton Of Fun",
        image: "assets/images/home/grid/gallery_35.png",
        videoId: "video_id_here",
        category: "TV Ads",
        showOnHomeGrid: false
    },
    {
        brandName: "Royal\nEnfield",
        title: "90 Degree South: Our Quest for the South Pole",
        image: "assets/images/home/grid/gallery_36.png",
        videoId: "-Nvh8hymLFU",
        category: "Webseries",
        showOnHomeGrid: false
    },
    {
        brandName: "PubG\nWeb Series India",
        title: "Dosti Ka Naya Maidan Episode 01 Trailer",
        image: "assets/images/home/grid/gallery_37.png",
        videoId: "k8-340mkogg",
        category: "Webseries",
        showOnHomeGrid: false
    },
    {
        brandName: "PubG\nWeb Series India",
        title: "Dosti Ka Naya Maidan Episode 01 Episode",
        image: "assets/images/home/grid/gallery_38.png",
        videoId: "DxKAA-KpQKA",
        category: "Webseries",
        showOnHomeGrid: false
    },
    {
        brandName: "PubG\nWeb Series India",
        title: "Dosti Ka Naya Maidan Episode 02 Trailer",
        image: "assets/images/home/grid/gallery_39.png",
        videoId: "hV6w27-zOO4",
        category: "Webseries",
        showOnHomeGrid: false
    },
    {
        brandName: "PubG\nWeb Series India",
        title: "Dosti Ka Naya Maidan Episode 02 Episode",
        image: "assets/images/home/grid/gallery_40.png",
        videoId: "8LxvaMF9nLg",
        category: "Webseries",
        showOnHomeGrid: false
    },
    {
        brandName: "PubG\nWeb Series India",
        title: "Dosti Ka Naya Maidan Episode 03 Trailer",
        image: "assets/images/home/grid/gallery_41.png",
        videoId: "bQXuIpf8_ig",
        category: "Webseries",
        showOnHomeGrid: false
    },
    {
        brandName: "PubG\nWeb Series India",
        title: "Dosti Ka Naya Maidan Episode 03 Episode",
        image: "assets/images/home/grid/gallery_42.png",
        videoId: "7wh-bP6Tgtw",
        category: "Webseries",
        showOnHomeGrid: false
    },
    {
        brandName: "PubG\nWeb Series India",
        title: "Dosti Ka Naya Maidan Episode 04 Trailer",
        image: "assets/images/home/grid/gallery_43.png",
        videoId: "crTjPkKQm1o",
        category: "Webseries",
        showOnHomeGrid: false
    },
    {
        brandName: "PubG\nWeb Series India",
        title: "Dosti Ka Naya Maidan Episode 04 Episode",
        image: "assets/images/home/grid/gallery_44.png",
        videoId: "ZbEy2hTpTVA",
        category: "Webseries",
        showOnHomeGrid: false
    },
    {
        brandName: "PubG\nWeb Series India",
        title: "Dosti Ka Naya Maidan Episode 05 Trailer",
        image: "assets/images/home/grid/gallery_45.png",
        videoId: "jotGHEtrY-g",
        category: "Webseries",
        showOnHomeGrid: false
    },
    {
        brandName: "PubG\nWeb Series India",
        title: "Dosti Ka Naya Maidan Episode 05 Episode",
        image: "assets/images/home/grid/gallery_46.png",
        videoId: "a5stwkYyLJk",
        category: "Webseries",
        showOnHomeGrid: false
    },
    {
        brandName: "Royal\nEnfield",
        title: "Ep 1 - The Legend Begins | Meteor 350 x BYOL | Royal Enfield Customs",
        image: "assets/images/home/grid/gallery_47.png",
        videoId: "79cfrOSxsec",
        category: "Webseries",
        showOnHomeGrid: false
    },
    {
        brandName: "Royal\nEnfield",
        title: "Ep 2 - The Teardown | Meteor 350 x BYOL | Royal Enfield Customs",
        image: "assets/images/home/grid/gallery_48.png",
        videoId: "oxezKM5NLdo",
        category: "Webseries",
        showOnHomeGrid: false
    },
    {
        brandName: "Royal\nEnfield",
        title: "Ep 3 - The Sum of Its Parts | Meteor 350 x BYOL | Royal Enfield Customs",
        image: "assets/images/home/grid/gallery_49.png",
        videoId: "gkVX7tXVg78",
        category: "Webseries",
        showOnHomeGrid: false
    },
    {
        brandName: "Royal\nEnfield",
        title: "Ep 4 - Its All in the details | Meteor 350 x BYOL | Royal Enfield Custom",
        image: "assets/images/home/grid/gallery_50.png",
        videoId: "gcMzpmzDwT4",
        category: "Webseries",
        showOnHomeGrid: false
    },
    {
        brandName: "Royal\nEnfield",
        title: "Ep 5 - The Legends Revealed | Meteor 350 x BYOL | Royal Enfield Customs",
        image: "assets/images/home/grid/gallery_51.png",
        videoId: "S_oD2sCA7Vo",
        category: "Webseries",
        showOnHomeGrid: false
    },
    {
        brandName: "Kellogg's\nGranola",
        title: "Multigrain breakfast with 24% Fruit & Nut",
        image: "assets/images/home/grid/gallery_52.png",
        videoId: "-55_rkakt7Q",
        category: "Product Films",
        showOnHomeGrid: false
    },
    {
        brandName: "Chairos\nWatches",
        title: "QNET India Watches | QNET - CHAIROS Signature",
        image: "assets/images/home/grid/gallery_53.png",
        videoId: "czmtIa9CnNU",
        category: "Product Films",
        showOnHomeGrid: false
    },
    {
        brandName: "Mercedes x\nRoger Federer",
        title: "Mercedes Benz C Class 2018 Never Stop Improving feat. Roger Federer",
        image: "assets/images/home/grid/gallery_54.png",
        videoId: "XS9bDuNgB3A",
        category: "Post Produced Films",
        showOnHomeGrid: false
    },
    {
        brandName: "Spotify x\nPodcast",
        title: "",
        image: "assets/images/home/grid/gallery_55.png",
        videoId: "UAq1ZIQxpUc",
        category: "Animation Films",
        showOnHomeGrid: false
    },
    {
        brandName: "Dream11 x\nFifa",
        title: "",
        image: "assets/images/home/grid/gallery_56.png",
        videoId: "rwYWKBcgqg8",
        category: "Animation Films",
        showOnHomeGrid: false
    },
    {
        brandName: "Gagan",
        title: "Gagan Diwali Rap Battle",
        image: "assets/images/home/grid/gallery_57.png",
        videoId: "Q5jdiQL2q_Q",
        category: "Animation Films",
        showOnHomeGrid: false
    },
    {
        brandName: "Valorant\nPromo Film",
        title: "Match Point | LAN Action Coming up | NODWIN Valorant Challengers South Asia 2023",
        image: "assets/images/home/grid/gallery_58.png",
        videoId: "uoX4hUNOnho",
        category: "TV Ads",
        showOnHomeGrid: false
    },

];
export const pages = [
    {
        name: "Home",
        component: Home,
        url: '/home',
        isNavBarComponent: true
    },
    {
        name: "Categories",
        component: Categories,
        url: '/categories',
        isNavBarComponent: true
    },
    {
        name: "About",
        component: About,
        url: '/about',
        isNavBarComponent: true
    },
    {
        name: "Contact",
        component: Contact,
        url: '/contact',
        isNavBarComponent: true
    },
]

export const mailLink: string = "sampatmeet02@gmail.com"
export const instagramLink: string = "https://www.instagram.com/storiesbymeetsampat/"
export const linkedinLink: string = "https://www.linkedin.com/in/meet-sampat-b452821a1/"